import {
  ContentCard,
  IconContainer,
  Label,
  MainContainer,
  Subtitle,
  TextContainer,
  Title,
} from "./NotAvailablePage.styles";
import { ReactComponent as NotAvailableIcon } from "../../assets/icons/notAvailable.svg";
const SUPPORT_EMAIL = "support@playbun.com";

const NotAvailablePage = () => {
  const handleClick = () => {
    const subject = encodeURIComponent("Support Request - Playbun.com");
    const body = encodeURIComponent(
      "Hello Support Team,\n\nI am experiencing the following issue:\n\n[Please describe your problem here]\n\nThank you,\n[Your Name]",
    );
    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
  };

  return (
    <MainContainer>
      <ContentCard>
        <IconContainer>
          <NotAvailableIcon />
        </IconContainer>

        <TextContainer>
          <Title>Not Available in Your Region</Title>
          <Subtitle>Using a VPN? 🌎</Subtitle>
          <Label>No worries, just turn it off and reload the page.</Label>
          <Subtitle>Any questions? 🙋</Subtitle>
          <Label>
            Please{" "}
            <Label $underline onClick={handleClick}>
              click here
            </Label>{" "}
            to reach out
          </Label>
        </TextContainer>
      </ContentCard>
    </MainContainer>
  );
};

export default NotAvailablePage;
